import * as React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useEffect } from 'react';

export const CustomizedSnackbar = ({ action, message, severityType="error" }) => {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        console.log(action)
        if(action){
            console.log(action)
            setOpen(true);
        }else{
            setOpen(false);
        }

    }, [action]);

    const openSnackbar = () => {
        setOpen(true);
    };

    const closeSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    }

    return (
        <>
            <Snackbar open={open} autoHideDuration={severityType === 'warning' ? null : 5000} onClose={closeSnackbar} anchorOrigin={{vertical:'top',horizontal:'right'}}>
                <Alert onClose={closeSnackbar} severity={severityType} sx={{ maxWidth: '500px', fontSize:'1rem' }} >
                    {message}
                </Alert>
            </Snackbar>

        </>
    )

}